import React, { FC, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import styles from './ResultPageContents.module.scss'
import CardsContent from '../molecules/CardsContent'
import Loading from '../atoms/Loading'
import { CardEntity } from '../../ducks/cards/types'
import { initialStateType as ActressInitialStateType } from '../../ducks/actresses/reducers'
import { QueryType } from '../../ducks/actresses/types'

interface PropsType {
  swipeCard(): void
  addModal(card: CardEntity): void
  cards: CardEntity[]
  modals: CardEntity[]
  actresses: ActressInitialStateType
  resetModal(): void
  searchActresses(query: QueryType): void
}

const ResultPageContents: FC<PropsType> = ({swipeCard, addModal, modals, resetModal, cards, searchActresses, actresses}) => {
  useEffect(() => {
    const query: QueryType = {}
    const params = new URLSearchParams(window.location.search)
    Array.from(params).map(param => {
      query[param[0]] = param[1]
    })
    searchActresses(query)
  }, [])

  return (
    <div className={ styles.mainContents }>
      <div className={ styles.resultSection }>
        <div className={ styles.sectionTitle }>
          検索結果
        </div>
        <div className={ styles.sectionSubTitle }>
          {cards.length}件 ヒット 
        </div>
        <div className={ styles.sectionBody }>
          {
            actresses.loading ?
              <Loading /> : 
              <CardsContent
                cards={cards}
                swipeCard={swipeCard}
                addModal={addModal}
                modals={modals}
                resetModal={resetModal} />
          }
        </div>
      </div>
      <div className={ styles.buttonsSection}>
        <Link to="/search">
          <div className={ styles.searchButton }>
            検索画面に戻る
          </div>
        </Link>
        <Link to="/">
          <div className={ styles.topButton }>
            トップに戻る
          </div>
        </Link>
      </div>
    </div>
  )
}

export default ResultPageContents